import React, { createContext, useContext, useEffect, useState } from "react";

const AppState = createContext(null);
export const useAppState = () => useContext(AppState);

// tab: "moods" (default landing) | "places" (globe) | "genres"
// view: "landing" | "filter" | "favorites" | "history" | "search" | "top" | "mood" | "decade"
export function AppStateProvider({ children }) {
  const [tab, setTab] = useState("moods");
  const [view, setView] = useState("landing");
  const [filters, setFilters] = useState({ country: null, tag: null, language: null, mood: null, decade: null });
  const [searchQuery, setSearchQuery] = useState("");

  // Sync tab → view for the landing pages
  const switchTab = (nextTab) => {
    setTab(nextTab);
    setView("landing");
    setFilters({ country: null, tag: null, language: null, mood: null, decade: null });
    setSearchQuery("");
  };

  return (
    <AppState.Provider value={{ tab, setTab: switchTab, view, setView, filters, setFilters, searchQuery, setSearchQuery }}>
      {children}
    </AppState.Provider>
  );
}
